
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/versioning",
      function () {
        return require("private-next-pages/docs/api/versioning.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/versioning"])
      });
    }
  